
//Currently only works for config mode 2 - sales area dialling
export function FilterCalls(config, calls) {
    if (config.DialMode === 2) {
        if (config.SalesArea.Only.length > 0) {
            //Config has ONLY dial sales areas
            return calls.filter(c => config.SalesArea.Only.indexOf(c.PipedriveSalesArea) !== -1) || [];
        }
        if (config.SalesArea.Ignored.length > 0) {
            console.log("Running Ignore")
            return calls.filter(c => config.SalesArea.Ignored.indexOf(c.PipedriveSalesArea) === -1) || [];
        }
    }
    return [];
}
